import { cn } from "@/lib/utils";

export function StatusBadge({ type, children }) {
  const styles = {
    delivered: "bg-[#34C759]/15 text-[#34C759] border-[#34C759]/30",
    notdelivered: "bg-[#FF3B30]/15 text-[#FF3B30] border-[#FF3B30]/30",
    paid: "bg-[#007AFF]/15 text-[#4DA3FF] border-[#007AFF]/30",
    unpaid: "bg-[#FFCC00]/15 text-[#FFCC00] border-[#FFCC00]/30",
    neutral: "bg-muted text-muted-foreground border-border",
    // delivery states
    livrat: "bg-[#34C759]/15 text-[#34C759] border-[#34C759]/30",
    retur: "bg-[#FF3B30]/15 text-[#FF3B30] border-[#FF3B30]/30",
    livrare: "bg-[#007AFF]/15 text-[#4DA3FF] border-[#007AFF]/30",
    depozit: "bg-[#FF9F0A]/15 text-[#FF9F0A] border-[#FF9F0A]/30",
    tranzit: "bg-[#AF7AFF]/15 text-[#AF7AFF] border-[#AF7AFF]/30",
    preluat: "bg-[#32D6C0]/15 text-[#32D6C0] border-[#32D6C0]/30",
    netrimis: "bg-muted text-muted-foreground border-border",
    anulat: "bg-[#8E8E93]/15 text-[#8E8E93] border-[#8E8E93]/30",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-xs font-mono font-medium whitespace-nowrap",
        styles[type] || styles.neutral
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: "currentColor" }} />
      {children}
    </span>
  );
}
